var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpworkJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7df23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38089,
    stopColor: "#86db3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#6fda44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a651"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.00995,32.06232l-.0011.0011c-4.71655.02283-8.30328,3.14325-9.64514,8.11511-2.25165-3.46582-4.00854-7.42993-5.01636-10.77722l-4.96509.02283.06158,13.15997c.00836,1.92346-1.13885,3.57678-2.78625,4.31927.75916.63379,1.36774,1.44208,1.73511,2.37732h1.37646c.617,0,1.20544.11566,1.75067.31952,1.79138-1.78314,2.90179-4.26874,2.8891-7.04004l-.01141-2.23456c1.00098,1.98035,2.25281,4.0849,3.62885,5.94214l-3.03601,14.53949,5.08936-.02283,2.18896-10.56403c1.9917,1.23358,4.21826,1.96667,6.83594,1.9541,5.46326-.02618,9.91302-4.51471,9.88452-10.22656-.04327-5.47815-4.50079-9.89398-9.97919-9.88562ZM65.08063,47.08521l-.0011.0011c-1.98602.00916-3.97546-.85046-5.59558-2.20947l.48682-1.98718v-.11401c.36487-2.11371,1.46161-5.71863,5.18744-5.73462,2.73431-.00452,4.96136,2.19556,4.99011,4.92975-.11169,2.8559-2.45917,5.10187-5.06769,5.11444Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.97729,29.49139l.06158,13.15997c.00513,1.07092.18213,2.0957.49548,3.05518.45782-.11383.93048-.19012,1.42303-.19012h4.08032c-.63086-.79797-1.02478-1.79181-1.03033-2.88782l-.06274-13.15997-4.96735.02277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.59399,59.48273h16.64551c1.4267,0,2.58325-1.15656,2.58325-2.58325v-2.56519c0-.58185-.47168-1.05359-1.05359-1.05359h-4.96893v-1.84021c0-1.06122-.86292-1.92407-1.92413-1.92407h-5.9187c-1.06097,0-1.92413.86285-1.92413,1.92407v1.84021h-4.96893c-.58191,0-1.05359.47174-1.05359,1.05359v2.56519c0,1.4267,1.15656,2.58325,2.58325,2.58325ZM32.67975,51.44049c0-.15326.12439-.27759.27765-.27759h5.9187c.15326,0,.27765.12433.27765.27759v1.84021h-6.474v-1.84021Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.82275,69.5451v-8.63153c-.74573.48157-1.63135.76453-2.58325.76453h-16.64551c-.95184,0-1.83746-.28296-2.58325-.76453v8.63153c0,.58185.47168,1.05359,1.05359,1.05359h19.70483c.58191,0,1.05359-.47174,1.05359-1.05359Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpworkJobs);
export default __webpack_public_path__ + "static/media/upwork-jobs.0cdd691731bb3a1a5d9101d9d1d028e5.svg";
export { ForwardRef as ReactComponent };